export const koodistoSources = {
  earlyChildhoodSubjects: 'earlyChildhoodEducationSubjects',
  earlyChildhoodObjectives: 'earlyChildhoodEducationObjectives',
  prePrimarySubjects: 'prePrimaryEducationSubjects',
  prePrimaryObjectives: 'prePrimaryEducationObjectives',
  basicStudySubjects: 'basicStudySubjects',
  basicStudyObjectives: 'basicStudyObjectives',
  basicStudyContents: 'basicStudyContents',
  preparatoryEducationSubjects: 'preparatoryEducationSubjects',
  preparatoryEducationObjectives: 'preparatoryEducationObjectives',
  upperSecondarySubjects: 'upperSecondarySchoolSubjects',
  upperSecondaryObjectives: 'upperSecondarySchoolObjectives',
  upperSecondarySubjectsOld: 'upperSecondarySchoolSubjectsOld',
  upperSecondaryCoursesOld: 'upperSecondarySchoolCoursesOld',
  upperSecondarySubjectsNew: 'upperSecondarySchoolSubjectsNew',
  upperSecondaryModulesNew: 'upperSecondarySchoolModulesNew',
  upperSecondaryObjectivesNew: 'upperSecondarySchoolObjectivesNew',
  upperSecondaryContentsNew: 'upperSecondarySchoolContentsNew',
  vocationalDegrees: 'vocationalDegrees',
  vocationalUnits: 'vocationalUnits',
  subjectOfCommonUnit: 'subjectOfCommonUnit',
  vocationalRequirements: 'vocationalRequirements',
  vocationalObjectives: 'vocationalEducationObjectives',
  furtherVocationalQualifications: 'furtherVocationalQualifications',
  specialistVocationalQualifications: 'specialistVocationalQualifications',
  selfMotivatedSubjects: 'selfMotivatedEducationSubjects',
  selfMotivatedObjectives: 'selfMotivatedEducationObjectives',
  scienceBranches: 'branchesOfScience',
  scienceBranchObjectives: 'scienceBranchObjectives',
  prerequisites: 'prerequisites'
}
